export enum GLOBAL_ROUTES {
  LANDING = '/',
}
